function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.98 8.09l-.17.43-4.72 13.23h-.18L7.18 8.5l-.16-.4c.06-.15.14-.29.22-.39l3.61-4.33c.63-.76 1.67-.76 2.3 0l3.61 4.33c.08.09.16.24.22.38z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M11.91 21.75c-.24-.01-.47-.07-.65-.18l-5.32-3.03c-.52-.3-.84-1.02-.73-1.6l1.72-8.57c.02-.08.05-.17.09-.27l.16.4 4.73 13.25zm6.15-3.21l-5.32 3.03c-.18.11-.41.17-.65.18l4.72-13.23.17-.43c.04.1.07.2.09.28l1.72 8.57c.11.58-.21 1.3-.73 1.6z"
})));